module.exports = __webpack_public_path__ + "img/hj_4.9fd5dafc.png";